import { render, staticRenderFns } from "./CartaoDePedidoDeCompra.vue?vue&type=template&id=0e1c07cc&scoped=true"
import script from "./CartaoDePedidoDeCompra.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoDePedidoDeCompra.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoDePedidoDeCompra.vue?vue&type=style&index=0&id=0e1c07cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1c07cc",
  null
  
)

export default component.exports